var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "complete_content",
      on: {
        click: function($event) {
          _vm.closeMenu()
        }
      }
    },
    [
      _c("dd-header", { attrs: { headerType: 2 } }),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: { pageKey: _vm.pageKey, pageList: _vm.pageList }
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1)
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("メールアドレス更新確認")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("ul", { staticClass: "thanks" }, [
        _c("li", { staticClass: "red" }, [
          _vm._v("※メールアドレスの更新はまだ完了しておりません。")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "ご入力いただいたメールアドレスに確認メールを送信いたしました。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "確認メールに記載されたリンクからログインし、更新処理を完了させてください。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "for_mail" }, [
        _c("li", [
          _vm._v("※受信制限をされている方は、「"),
          _c("label", { staticClass: "weighty" }, [_vm._v("@domans.co.jp")]),
          _vm._v("」からのメールを受信許可に設定してください")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "※メールアドレスを間違えて入力してしまった場合は、再度更新手続きを行ってください。"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d2f9450", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d2f9450","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcUpdateAccountConfirm.vue
// module id = null
// module chunks = 